// DesignContent.js
import dayjs from 'dayjs';
import DateLogic from "..//../utils/DateLogic";
import { getTranslations } from "..//../utils/CardTranslations";

const DesignContent = ({ data }) => {
  const isClassicTemplate = data.designTemplate === "classic";
  const t = getTranslations(data.language);

  return (
    <div style={{
      alignContent: 'center',
      padding: '20px',
      color: data.themeColour || 'black',
      fontFamily: "Playfair, serif",
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      height: '100%',
      ...(!isClassicTemplate && data.cardBackground ? {
        backgroundImage: `url(${data.cardBackground})`,
        backgroundSize: "100% 100%",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      } : {})
    }}>
      <p style={{
        fontSize: `${(data.fontSizeMajlis || 14) * 0.6667}px`,
        lineHeight: data.textLayoutMajlis === 'break' ? '1' : 'normal'
      }}>
        {data.textLayoutMajlis === 'break'
          ? data.eventType.split(' ').map((word, index) =>
            index === 0 ? word : <><br />{word}</>)
          : data.eventType}
      </p>

      {/* Couple 1 names */}
      <p style={{
        fontSize: `${(data.fontSizePengantin || 24) * 0.6667}px`,
        fontWeight: 'bold',
        fontFamily: data.fontBrideStyle,
        color: data.themeColour,
        margin: '20px 0 0',
        whiteSpace: 'pre-line'
      }}>
        {data.coupleCount === 'dua' ? data.greetingName || 'Adam & Hawa' : (data.greetingName || 'Adam & Hawa')?.replace(/ & /g, '\n&\n')}
      </p>

      {/* Couple 2 names — only when coupleCount === 'dua' */}
      {data.coupleCount === 'dua' && data.greetingName2 && (
        <>
          <p style={{ fontSize: '9px', margin: '8px 0 4px', letterSpacing: '1px' }}>{t.together}</p>
          <p style={{
            fontSize: `${(data.fontSizePengantin || 24) * 0.6667}px`,
            fontWeight: 'bold',
            fontFamily: data.fontBrideStyle,
            color: data.themeColour,
            margin: '0 0 20px',
            whiteSpace: 'pre-line'
          }}>
            {data.greetingName2}
          </p>
        </>
      )}

      <p>{DateLogic.toDay(dayjs(data.eventDate).format('dddd'), data.language)}</p>
      <p>{DateLogic.formatDate(data.eventDate, 'D MMM YYYY', data.language)}</p>
      <p style={{ marginTop: '20px' }}>{data.place}</p>
    </div>
  );
};

export default DesignContent;
